import axios from "axios";
import { API } from "../../../api/api";

export const getProjectDetail = async (id: string) =>
  await axios.get(`${API.url}/projects/${id}?populate=*`).then((res) => res.data?.data?.attributes);

// export const getHowWeOperate = async () =>
//   await axios.get(`${API.url}/how-we-operates`).then((res) => res.data.data);
